import React from 'react'

import { AdministrationList } from '../../../List'

// Queries
import { DELETE_LOGICS, LIST_LOGICS } from './queries'

const table = [
  { th: 'ID', td: 'id' },
  { th: 'Protocolo', td: ['protocol', 'name'] },
  { th: 'Descripción', td: 'name' },
]

const queries = { list: LIST_LOGICS, delete: DELETE_LOGICS }

const AdministrationListAnalysisLogics = () => (
  <AdministrationList table={table} queries={queries} />
)

export default AdministrationListAnalysisLogics
